let load = require('./helpers/browser/esm-js-loader');
module.exports = Promise.all([load("fliVL"), load("9BfG7")]).then(() => parcelRequire('9AdN4'));